import React from 'react';

export const FlatlineDetectorBadge: React.FC = () => {
  return (
    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
      ⚠️ Flatline
    </span>
  );
};